import '.d{display:flex;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { useState } from 'react'
import { IconButton } from '@app/components/core/button/IconButton'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'

export type DataSectionItem = {
  label: string
  content: string
}
export type FaqContentSectionType = {
  type: 'faqs'
  title: string
  listItems: DataSectionItem[]
}

export const FaqContentSection = ({
  title,
  listItems,
}: FaqContentSectionType) => {
  const isMobile = useMediaQuery()
  return (
    <div className="d g"
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        padding: isMobile ? '2rem' : '4rem',
      }}
    >
      <Title.H2 style={{ fontSize: '5.625rem' }}>{title}</Title.H2>
      <Column alignItems="stretch" gap={0}>
        {listItems.map((i, index) => (
          <FaqItem key={`${i.label}-${index}`} {...i} />
        ))}
      </Column>
    </div>
  )
}

const FaqItem = ({ label, content }: DataSectionItem) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Column
      gap={'0.5rem'}
      style={{ paddingBlock: '1.5rem', borderBottom: '1px solid #000' }}
    >
      <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <Title.H3>{label}</Title.H3>
        <IconButton
          icon={isOpen ? faMinus : faPlus}
          onClick={() => setIsOpen((p) => !p)}
        />
      </Row>

      {isOpen && <Text>{content}</Text>}
    </Column>
  )
}
